export default "__VITE_ASSET__BMVH_KZ$__"